import { QuestionViewPropsFor } from '@/components/question/view/types';
import { QuizAnswer } from '@/models/Answer';
import { QuestionTypeEnum } from '@/models/Question';
import { useMemo } from 'react';

export type QuizOption = {
  id: number;
  index: number;
  answer: QuizAnswer;
  isSelected: boolean;
};

export function useQuizAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.QUIZ>,
) {
  const { question, value, mode } = props;
  const onChange = props.mode === 'answering' ? props.onChange : undefined;

  const selectedIds = useMemo(() => value ?? [], [value]);

  const options = useMemo<QuizOption[]>(
    () =>
      question.quizAnswers.map((answer, index) => ({
        id: answer.id,
        index,
        answer,
        isSelected: selectedIds.includes(answer.id),
      })),
    [question.quizAnswers, selectedIds],
  );

  const selectedValues = useMemo(() => selectedIds.map(String), [selectedIds]);

  const disabled = mode !== 'answering';

  const handleChange = (values: string[]) => {
    onChange?.(values.length ? values.map(Number) : null);
  };

  return { options, selectedValues, handleChange, disabled };
}
